<template>
  <div class="validate-condition-editor">
    <div class="content-wrap">
      <div class="rule-list">
        <ul>
          <li
            v-for="(rule, index) in valueList"
            :key="index"
            class="list-item"
            :class="{ active: currentRuleIdx == index }"
            @click="currentRuleIdx = index"
          >
            <span class="color-Gray_9e">{{ index + 1 }}、</span>
            <div class="main">
              <div v-if="rule.msg.length" class="main-msg">
                {{ rule.msgShow }}
              </div>
              <div class="color-Gray_9e">满足条件阻断操作</div>
            </div>
            <div class="operation color-Gray_9e">
              <base-button
                type="text"
                icon="el-icon-edit"
                @click="openConditionDialog(index)"
              ></base-button>
              <base-button
                type="text"
                icon="el-icon-delete-solid"
                @click="deleteRule(index, rule)"
              ></base-button>
            </div>
          </li>
          <li class="add-box" @click="openConditionDialog()">+ 添加新规则</li>
        </ul>
      </div>
    </div>
    <setting-validate-rule-dialog
      ref="settingValidateRuleDialog"
      :validateExtra="validateExtra"
      :flowConnectedData="flowConnectedData"
      :workflow-var-group-string-map="workflowVarGroupStringMap"
      :flowVarGroup="flowVarGroup"
      @submit="conditionSubmit"
    ></setting-validate-rule-dialog>
  </div>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button"
import SettingValidateRuleDialog from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/SettingValidateRuleDialog"

export default {
  name: "validate-condition-editor",
  components: {
    BaseButton,
    SettingValidateRuleDialog
  },
  data() {
    return {
      currentRuleIdx: -1,
      msgName: {}
    }
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    validateExtra: Object,
    flowConnectedData: Array,
    flowVarGroup: Array,
    workflowVarGroupStringMap: Object
  },
  computed: {
    valueList() {
      return this.value.map(item => {
        let msg = item.msg
        let msgArr = msg.split("+")
        let result = ""
        msgArr.forEach(m => {
          result = result + (m.includes("dealNull") ? this.workflowVarGroupStringMap[m] : m)
        })
        item.msgShow = result.replace(/'/g, " ")
        return item
      })
    }
  },
  methods: {
    // 删除一个字段规则
    deleteRule(index, rule) {
      this.currentRuleIdx = -1
      this.value.splice(index, 1)
      this.emitValue(this.value)
      this.$emit("deleteConditionMap", rule.msgShow)
    },
    emitValue(value) {
      this.$emit("input", value)
    },
    openConditionDialog(index = -1) {
      this.currentRuleIdx = index
      this.$refs.settingValidateRuleDialog.open(index < 0 ? null : this.value[index])
    },
    conditionSubmit(condition) {
      if (this.currentRuleIdx < 0) {
        this.emitValue(this.value.concat(condition))
      } else {
        this.value.splice(this.currentRuleIdx, 1, condition)
        this.emitValue(this.value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.validate-condition-editor {
  display: flex;
  .tip {
    flex: 1;
    height: 36px;
    line-height: 36px;
    background: #f8f8f8;
    border-radius: 4px;
    padding: 0 17px;
    box-sizing: border-box;
    color: #c0c4cc;
  }
  .content-wrap {
    flex: 1 1;
    box-sizing: border-box;
    .title {
      font-size: 16px;
    }
    .title-tips {
      font-size: 14px;
    }
    .rule-list {
      li {
        cursor: pointer;
        &:hover {
          background-color: #e9f5fe;
        }
      }
      .list-item {
        display: flex;
        line-height: 23px;
        margin-bottom: 12px;
        padding: 10px 10px;
        font-size: 13px;
        background-color: #f7f7f7;
        border-radius: 4px;
        box-sizing: border-box;
        &.active {
          background-color: #e9f5fe;
        }
        .main {
          flex: 1 1;
          .main-msg {
            max-width: 356px;
            word-wrap: break-word;
          }
          .tip-text {
            margin-left: 6px;
          }
        }
        .operation {
          .el-icon-delete-solid {
            padding: 2px;
            &:hover {
              color: #f44336;
            }
          }
        }
      }
      .add-box {
        height: 32px;
        border-radius: 4px;
        color: #2196f3;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        border: 1px dashed #ccc;
        &:hover {
          color: #0073ce;
          border: 1px dashed #2196f3;
        }
      }
    }
  }
  ::v-deep .base-button {
    color: #a1a1a1;
    &:hover {
      color: #1989fa;
    }
  }
}
</style>
